export default {
  pageTitle: {
    en: 'The Perfect Gift: Perfume Subscription Starting at $44 | Scentbird.com',
  },
  pageDescription: {
    en: `
      Shop perfume gift at Scentbird.com.
      View our unrivaled assortment from top brands
      and find a luxurious perfume gift set for every woman in your life.
    `,
  },
  brandsTitle: {
    en: 'All the designer fragrances you can imagine in one place',
  },
  brandsSubTitle: {
    en: 'Check out our brand portfolio below.',
  },
}
